var grecaptcha;
function Form() {
	var self = this;
	this.init();
}

Form.prototype.init = function () {
	var self = this;
	self.multiply_sum = 1;
	self.sendForm();
	self.handleShowFormButton();
	self.handleCustomSelectZIndex();	
	self.updateStatementsView();
	self.updateCalculations();
	self.handleCopyBtn();
	self.updateDropdown();
	self.updateFiltersView();
	self.observeForm();
	self.updateFormPrice();
};

Form.prototype.updateFiltersView = function() {
	//console.log("updateFiltersView");
	var dataFields = [];
	$.each( $("div[data-fields]"), function (i,v) {
		var _dataFields = $(v).attr('data-fields');
		var item = {};
		if (_dataFields) {
			item.fields = _dataFields;
			item.observe = $(v).attr('data-name');
			dataFields.push( item );
		}
	});
	this.dataFields = dataFields;
};

Form.prototype.initCopyBtn = function() {
	var self = this;
	self.dataCopy = {};
	//dodawanie "[]" w name dla wszystkich kopiowanych pol
	var ids = [];
	$.each($('.form-copy-btn'), function(i, j) {
		if ($(j).attr('data-copyIds') && $(j).attr('data-copyIds').length) {
			var strCopyIds = $(j).attr('data-copyIds') ? $(this).attr('data-copyIds') : '';
			var copyIds = strCopyIds.split(',');
			ids = ids.concat(copyIds);
		}
	});
	if (ids.length) {
		$.each(ids, function(i, j){
			var el_ = $('.field-container:not(.is-copy) input[name="' + j + '"]');
			if (el_.length == 0)
				el_ = $('.field-container:not(.is-copy) label[for="' + j + '"]');
			var el = $($(el_[0]).closest('.field-container'));
			// var regex = new RegExp('"'+j+'"', 'g');
			var newEl = el.clone().prop('outerHTML');
			// newEl = newEl.replace(regex, '"'+j+ '[]"');
			var regex2 = new RegExp(' field-container');
			newEl = newEl.replace(regex2, ' field-container ' + j);
			el.replaceWith(newEl);
			self.dataCopy[j] = [];
		});
		//console.log(self.dataCopy);
		$("input[name=copy-ids]").val(ids);
	}
};

Form.prototype.handleCopyBtn = function() {
	var self = this;
	this.initCopyBtn();
	$('body').on('click', '.form-copy-btn', function(e){
		e.preventDefault();
		var strCopyIds = $(this).attr('data-copyIds') ? $(this).attr('data-copyIds') : '';
		var suffix = $(this).attr('data-suffix') ? $(this).attr('data-suffix') : 1;
		$(this).attr('data-suffix', suffix + 1);
		var copyIds = strCopyIds.split(',');
		var paste =  $(this);
		var newHtml = "";
		var addRow = 0;
		$.each(copyIds, function(i, j){
			var el_ = $('.field-container.'+j+':not(.is-copy)');
			var dataFields = $(el_).find('.dropdown-wrapper').attr('data-fields');
			//dodawanie div/row
			if (i===0) {
				if ($(el_).hasClass('first_child')) {
					addRow = 1;
					paste = $(el_).closest('.row');//parent();
				}
				else
					addRow = 0;
			}

			var el = $($(el_[0])).clone();

			if (dataFields) {
				$(el).find('.dropdown-wrapper').attr('data-fields', dataFields + '-' + suffix);
			}

			var dataDefault = el.find('input[type=hidden]').attr('data-default') ? el.find('input[type=hidden]').attr('data-default') : '';

			el.find('.select-box__text').html( el.find('a.show-all-time').html( el.find('a[data-value="'+dataDefault+'"]').html() ) );
			el.find('input[type=hidden]').val( el.find('input[type=hidden]').attr('data-default') );

			el.removeClass("error");
			el.find('span.errorinfo').removeClass('-active');
			el.find('input.error').removeClass('error');
			el.find('select-block').removeClass('error');

			el.addClass('is-copy');
			el = el.prop('outerHTML');
			var regex = new RegExp(j, 'g');
			el = el.replace(regex, j + '-' + suffix);

			//console.log(j + " -> " + j + '-' + suffix);
			self.updateDataStaments(j.replace('f_', ''), j.replace('f_', '') + '-' + suffix, suffix);
			self.updateDataObserveFilter(j.replace('f_', ''), j.replace('f_', '') + '-' + suffix, suffix);

			//wstawianie przed przyciskiem btn-copy
			self.dataCopy[j].push(suffix);
			newHtml += el;
		});
		//$(".container-form div.field-container:nth-child(" + index + ")").before(el);
		//console.log('addRow ' + addRow);
		if (addRow==1) {
			newHtml = '<div class="row">' + newHtml + '</div>';
			$(paste).after(newHtml);
		} else
			$(paste).before(newHtml);
		//console.log(self.dataCopy);
		$("input[name=data-copy]").val(JSON.stringify(self.dataCopy));
		//console.log(self.dataStaments);
	});
};

Form.prototype.updateDropdown = function() {
	var self = this;

	$('.dropdown-wrapper').each(function() {
		// var form = $(this).attr('data-name');
		// var value = $(this).closest('.select-block').find('input[name="'+form+'"]').val();
		// var dropdown = $(this);
		// if (value) {
		// 	$(this).find('.select-dropdown-element').each(function() {
		// 		if ($(this).attr('data-value') == value) {
		// 			$(this).siblings().removeClass('-active');
		// 			$(this).addClass('-active');
		// 		}
		// 	});
		// }
		if ($(this).find('.select-dropdown-element.-active').length) {
			var $elem = $(this).find('.select-dropdown-element.-active');
			var text = $elem.text();
			$(this).find('.select-box__text').text('');
			$(this).find('.select-box__text').text(text);
			
			//$elem.hide();  //problem z form zapisz sie na studia ukryta opcja w select
		}
	});
};

Form.prototype.updateFormPrice = function() {
	var self = this;
	var netto = 0.0;
	var brutto = 0.0;

	var multiply_sum = ( self.multiply_sum != 1 ? self.multiply_sum : 1);

	//console.log(multiply_sum);
	
	$.each($('form .number-input [data-price]'), function(i,v){
		var count = parseFloat($(v).val() ? $(v).val() : 0);
		var max = parseInt($(v).attr('max'));
		var min = parseInt($(v).attr('min'));
		if (count>max) {
			$(v).val(max);
			count = max;
		} else if (count<min) {
			$(v).val(min);
			count = min;
		}
		var priceNetto =  count * parseFloat($(v).attr('data-price')) * multiply_sum;
		netto += priceNetto;
		brutto += priceNetto * (1 + parseFloat($(v).attr('data-vat'))/100);
	});

	$.each($('form .input13 [data-price]:checked'), function(i,v){
		var priceNetto = parseFloat($(v).attr('data-price')) * multiply_sum;
		netto += priceNetto;
		brutto += priceNetto * (1 + parseFloat($(v).attr('data-vat'))/100);
	});

	//mnoznik ceny globalnie
	//netto = netto * self.multiply_sum;
	//brutto = brutto * self.multiply_sum;

	//console.log('Netto: ' + netto.toFixed(2) + ' brutto: '+brutto.toFixed(2));
	$('.form_summary').val('Netto: ' + netto.toFixed(2) + ', brutto: ' + brutto.toFixed(2));
	$('.label_summary').html('Razem ' + netto.toFixed(2) + ' zł netto, ' + brutto.toFixed(2) + ' zł brutto');
};

Form.prototype.updateCalculations = function() {
	var self = this;
	var dataPrice = $('form [data-price]').length;
	if (dataPrice) {
		var int = setInterval(function() {
			self.updateFormPrice();
		}, 50);
	}
};

Form.prototype.updateDataStaments = function(key, newKey, suffix) {
	var self = this;
	if (self.dataStaments.id) {
		$.each(self.dataStaments.id, function(i, id){
			if (id==key) {
				//console.log(key + ' -> ' + newKey);
				//var suffix = newKey.replace(key, '');
				var hide_fields = self.dataStaments.hide_fields[i].slice();
				var show_fields = self.dataStaments.show_fields[i].slice();
				var value = self.dataStaments.value[i];
				//console.log(hide_fields);
				//console.log(show_fields);
				$.each(hide_fields, function(k, m) {
					hide_fields[k] = m + "-" + suffix;
				});
				$.each(show_fields, function(k, m) {
					show_fields[k] = m + "-" + suffix;
				});
				self.dataStaments.id.push(newKey);
				self.dataStaments.hide_fields.push(hide_fields);
				self.dataStaments.show_fields.push(show_fields);
				self.dataStaments.value.push(value);
				// console.log(hide_fields);
				// console.log(show_fields);
			}
		});
		//console.log(self.dataStaments);
	}
};

Form.prototype.updateDataObserveFilter = function(key, newKey, suffix) {
	var self = this;
	if (self.dataFields) {
		//console.log('key '+key+" newKey "+newKey + " suffix "+suffix);
		$.each(self.dataFields, function(i, row){
			//console.log(row);
			if (row.fields == 'f_'+key) {
				self.dataFields.push({'fields' :  row.fields + "-" + suffix, 'observe' :  row.observe + "-" + suffix});
			}
		});
		//console.log(self.dataFields);
	}
};

Form.prototype.updateFormFields = function(index) {
	var self = this;
	//console.log(self.dataStaments);
	var show_fields = self.dataStaments.show_fields[index];
	var hide_fields = self.dataStaments.hide_fields[index];
	var discount_fields = self.dataStaments.discount_fields[index];
	var discount = self.dataStaments.discount[index];
	var multiply = self.dataStaments.multiply[index];
	var multiply_sum = self.dataStaments.multiply_sum[index];
	//console.log(discount_fields);

	if (show_fields)
		$.each(show_fields, function(j,k){
			var f = $('[name=f_' + k +']');
			var block = f.closest('.field-container');
			block.removeClass('-hide');
		});
	
	if (hide_fields)
		$.each(hide_fields, function(j,k){
			var f = $('[name=f_' + k +']');
			var block = f.closest('.field-container');
			block.addClass('-hide');
		});

	if (discount_fields)
		$.each(discount_fields, function(j,k){
			var f = $('[name=f_' + k +']');
			//console.log(f);
			var block = f.closest('.field-container');
			$.each($(block).find('[data-price]'), function(m, n) {
				var newPrice = parseFloat($(n).attr('data-basePrice') * multiply).toFixed(2);
				var newPriceDiscount = parseFloat($(n).attr('data-basePrice') * multiply * (100 - discount)/100).toFixed(2);
				$(n).attr('data-price', newPriceDiscount );
				//console.log('f_' + k + 'newPrice '+ newPrice + 'newPriceDiscount ' + newPriceDiscount);
				if (newPrice!=newPriceDiscount)
					$(block).find('p.field-description').html("<span style='text-decoration: line-through'>" + newPrice + "zł </span>" + newPriceDiscount + " zł");
				else
					$(block).find('p.field-description').html(newPriceDiscount + " zł");
			});
		});

	//console.log('Moznik ceny: ' + multiply_sum);
	self.multiply_sum = multiply_sum;		
};

//obserwacja wszystkiego interwal
Form.prototype.observeForm = function() {
	var self = this;
	//console.log(self.dataStaments.id);
	if ($('form[data-staments]').length) {
		if (self.dataStaments.id) {
			$.each(self.dataStaments.id, function(i,v) {
				var el = $('[name=f_' + self.dataStaments.id[i] +']');
				if (el.length > 1)
					el = $('[name=f_' + self.dataStaments.id[i] +']:checked');
				isHide = el.closest('.field-container').hasClass('-hide') ? 1 : 0;
				//console.log(self.dataStaments.id[i] + ' ' + isHide);
				if (el.val() == self.dataStaments.value[i] && isHide===0) {
					self.updateFormFields(i);
				}
			});
		}

		//console.log(self.dataFields);

		if (self.dataFields) {
			$.each(self.dataFields, function(i,v) {
				var selDiv = $('.select-container.' + v.fields);
				var el = $('.select-container.' + v.fields + ' input[name=' + v.fields + ']');
				if (el && !selDiv.hasClass('filter-done')) {
					//ukryj wszystkie
					var sel = $('.select-container.' + v.observe);
					sel.find('.select-dropdown-background a:not(.show-all-time)').hide();
					sel.find('.select-box__text').html( sel.find('a.show-all-time').html() );
					//console.log(sel.find('input[type=hidden]').length);
					//sel.find('input[type=hidden]').val( sel.find('input[type=hidden]').attr('data-default'));

					//pokaz te z filtrem
					sel.find('.select-dropdown-background a[data-filter='+ $(el).val() +']').show();
					selDiv.addClass('filter-done');
				}
			});
		}
	}
};

Form.prototype.updateStatementsView = function() {
	var self = this;
	var dataStaments = $('form[data-staments]').attr('data-staments');
	// console.log( JSON.parse(dataStaments) );
	if (dataStaments) {
		self.dataStaments = JSON.parse( dataStaments );
		$('form[data-staments]').find('input[type="radio"], input[type="checkbox"]').on('change input', function() {
			self.observeForm();
		});
		$('body').on('click', 'form[data-staments] .dropdown-wrapper .select-dropdown-element', function() {
			self.observeForm();
		});
	}
};

Form.prototype.sendForm = function() {
	var self = this;
	// console.log('sendForm');
	$('form.ajax').on('submit', function (e) {
		e.preventDefault();
		console.log('ajax');
		var self	 = $(this);
		var url 	 = $(this).attr('action');
		var formData = $(this).serialize();
		var id = $( this ).attr('id');
		self.find('input').attr('disabled','disabled');
		self.addClass('-sending');
		self.closest('.container-form').addClass('-sending');
		$.ajax({
			type        : 'POST',
			url         : url,
			data        : formData,
			dataType    : 'json',
		}).done(function(data) {
			self.find('div.error').removeClass("error");
			self.find('span.errorinfo').removeClass('-active');
			self.find('input.error').removeClass('error');
			self.closest('.container-form').removeClass('-sending');
			if (data.fails) {
				for (var name in data.errors) {
					var span = self.find('span[data-form="'+name+'"]');
					$('input[name="'+name+'"]').addClass('error');
					span.html(data.errors[name]).addClass('-active').parent().addClass('error');
				}
				self.removeClass('-sending').find('input').removeAttr('disabled');
				if (id=='i-recaptcha' && grecaptcha!==undefined)
					grecaptcha.reset();
			}
			else {
				if (data.redirect !== undefined) {
					self.closest('.form-wrapper').addClass('-thankyou');
					if (data.redirect != "")
						window.location = data.redirect;
					//console.log('data.redirect');
				}
				else {
					//if (self.attr('data-thankyou') && self.attr('data-thankyou') !== '') {
					if (data.thankyou && data.thankyou !== '') {
						var thankyou = data.thankyou;
						if (self.closest('.form-container').length){ 
							self.closest('.form-container').after('<div class="thankyou">'+thankyou+'</div>');
						} else {
							self.after('<div class="thankyou">'+thankyou+'</div>');
						}
						//console.log('data.thankyou');
						if (data.dotpay)
							window.location = data.dotpay;
					} else {
						if (self.closest('.form-container').length) {
							self.closest('.form-container').after('<h3>Wysłano poprawnie formularz<br>Dziękujemy!</h3>');
						} else {
							self.after('<h3>Wysłano poprawnie formularz<br>Dziękujemy!</h3>');
						}
						//console.log('no data.thankyou');
					}
					if (self.closest('.form-container').length) {
						self.closest('.form-container').remove();
					} else {
						self.remove();
					}
				}
			}
		});
	});
	function removeSpecialCharacters(str_) {
		if (str_===undefined) return "";
		var str = "";
		str+=str_;
		var mapObj = {
			ó:"o",
			ł:"l",
			ń:"n",
			ę:"e",
			ą:"a",
			ś:"s",
			ć:"c",
			ź:"z",
			ż:"z"
		};
		str = str.replace(/ó|ł|ń|ę|ę|ą|ś|ć|ż|ź/gi, function(matched) {
			return mapObj[matched];
		});
		return str;
	}
	$('form.employee-search').submit(function(e){
		e.preventDefault();
		$('.cloned').remove();
		var input = $('form.employee-search input').val();
		var result = input.toLowerCase().split(" ");
		//console.log(result);
		var regularName = new RegExp(removeSpecialCharacters(result[0]));
		var regularSurname = new RegExp(removeSpecialCharacters(result[1]));
		if ($('.result-list').is(':empty')) {
			$('.no-results').removeClass('-hidden');
		}
		$('.hide-for-small-only > .accordion-content > div > a').each(function(){
			var employ = removeSpecialCharacters($(this).text().toLowerCase());
			if (input) {
				$('.result').removeClass('-hidden');
			} else {
				return;
			}
			if (regularName.test(employ) && regularSurname.test(employ)) {
				$('.no-results').addClass('-hidden');
				$(this).clone().prependTo('.result-list').addClass('cloned');
			}
		});
	});
	$('.result > .close').click(function(){
		$('.result').addClass('-hidden');
		$('.cloned').remove();
	});
};

Form.prototype.handleShowFormButton = function() {
	var self = this;

	$('a.show-form').on('click', function(e) {
		e.preventDefault();
		$(this).addClass('-hidden');
		$(this).siblings('.form-container').removeClass('-hidden');
	});
};

Form.prototype.handleCustomSelectZIndex = function() {
	var self = this;
	
	$('.select-container').each(function(i, v) {
		$(this).css({
			'position': 'relative',
			'z-index': parseInt(100-i)
		});
	});
};

function recaptchaOnSubmit(token) {
	$('#i-recaptcha').submit();
}